App.factory('zochaInsuranceService', ['$q', 'baseService', 'Config', function($q, baseService, Config) {
    function ZochaInsuranceService() {
        this.dataList = function(data) {
            return baseService.post(Config.API_URL + '/zocha/insuranceDeclaration/list', data).then(function(success) {
                return success;
            }, function(error) {
                return error;
            });
        };

        this.add = function(data) {
            return baseService.post(Config.API_URL + '/zocha/insuranceDeclaration/save', data).then(function(success) {
                return success;
            }, function(error) {
                return error;
            });
        };

        this.originalCopyEntered = function(id) {
            return baseService.get(Config.API_URL + '/zocha/insuranceDeclaration/' + id + '/originalCopyEntered').then(function(success) {
                return success;
            }, function(error) {
                return error;
            });
        };

        this.active = function(id) {
            return baseService.get(Config.API_URL + '/zocha/insuranceDeclaration/' + id + '/active').then(function(success) {
                return success;
            }, function(error) {
                return error;
            });
        };

        this.cancel = function(id) {
            return baseService.get(Config.API_URL + '/zocha/insuranceDeclaration/' + id + '/cancel').then(function(success) {
                return success;
            }, function(error) {
                return error;
            });
        };

        this.withdraw = function(criteria) {
            return baseService.post(Config.API_URL + '/zocha/insuranceDeclaration/' + criteria.id + '/withdraw', criteria.data).then(function(success) {
                return success;
            }, function(error) {
                return error;
            });
        };

        this.notify = function(criteria) {
            return baseService.post(Config.API_URL + '/zocha/insuranceDeclaration/' + criteria.id + '/notify', criteria.data).then(function(success) {
                return success;
            }, function(error) {
                return error;
            });
        };

        this.getDeclaration = function(uuid) {
            return baseService.download(Config.API_URL + '/zocha/insuranceDeclaration/' + uuid + '/declaration').then(function(success) {
                return success;
            }, function(error) {
                return error;
            });
        };

        this.getStatement = function(uuid) {
            return baseService.download(Config.API_URL + '/zocha/insuranceDeclaration/' + uuid + '/statement').then(function(success) {
                return success;
            }, function(error) {
                return error;
            });
        };

        this.enterOriginalCopyBarcode = function(id) {
            return baseService.get(Config.API_URL + '/zocha/insuranceDeclaration/enterOriginalCopyBarcode/' + id).then(function(success) {
                return success;
            }, function(error) {
                return error;
            });
        };

    }
    return new ZochaInsuranceService();
}]);
